export const getRequestApprovalByIdRequest = (id) => {
  return id;
};

export default getRequestApprovalByIdRequest;
